
export enum CisRequestPriorityCd {
	NO_SPECIAL_PRIORITY = 'NoSpecialPriority',
	REQUIRED_FOR_BILLING = 'RequiredForBilling',
	RFP_PENDING = 'RFPPending'}

